import { type ReactNode } from 'react'

import { DrillInPageHeader, type DrillInPageHeaderProps } from './drill-in-page-header'

export type DrillInPageLayoutProps = DrillInPageHeaderProps & {
  children: ReactNode
}

export const DrillInPageLayout = ({ children, ...headerProps }: DrillInPageLayoutProps) => {
  return (
    <div className='flex h-full min-h-0 w-full min-w-0 flex-col'>
      <DrillInPageHeader {...headerProps} />
      <div className='flex min-h-0 flex-1 flex-col overflow-y-auto'>{children}</div>
    </div>
  )
}
